export enum EStopCorrectionTypeForShipper {
  STOP_UPDATED_TYPE = 'STOP_UPDATED_TYPE',
  STOP_UPDATED_UNLOADED_WEIGHT = 'STOP_UPDATED_UNLOADED_WEIGHT',
  STOP_UPDATED_UNLOADED_PACKAGES = 'STOP_UPDATED_UNLOADED_PACKAGES',
}

export enum EValidationErrorTypeForShipper {
  STOPS_INVALID_DATES = 'STOPS_INVALID_DATES',
  STOPS_INVALID_UNLOADED_VALUES = 'STOPS_INVALID_UNLOADED_VALUES',
  STOP_WITHOUT_ADDRESS = 'STOP_WITHOUT_ADDRESS',
  // INVALID_WEIGHT = 'INVALID_WEIGHT',
  // INVALID_PACKAGES = 'INVALID_PACKAGES',

  STOP_MISSING_WEIGHT = 'STOP_MISSING_WEIGHT',
  STOP_MISSING_PACKAGES = 'STOP_MISSING_PACKAGES',
  STOP_INVALID_GOODS_DESCRIPTION = 'STOP_INVALID_GOODS_DESCRIPTION',
  STOP_MISSING_UNLOADED_WEIGHT = 'STOP_MISSING_UNLOADED_WEIGHT',
  STOP_MISSING_UNLOADED_PACKAGES = 'STOP_MISSING_UNLOADED_PACKAGES',
  STOP_MISSING_UNTIL_DATE = 'STOP_MISSING_UNTIL_DATE',
  STOP_MISSING_SINCE_DATE = 'STOP_MISSING_SINCE_DATE',
  STOP_SINCE_BEFORE_NOW = 'STOP_SINCE_BEFORE_NOW',
  STOP_UNTIL_BEFORE_SINCE = 'STOP_UNTIL_BEFORE_SINCE',
}

export interface IStopCorrectionForShipper {
  stopId: string;
  correctionType: EStopCorrectionTypeForShipper;
  oldValue?: any;
  newValue: any;
}

export interface IValidationErrorForShipper {
  stopId: string;
  errorType: EValidationErrorTypeForShipper;
  field?: string;
}

export interface IValidationResultForShipper {
  hasErrors: boolean;
  corrections: IStopCorrectionForShipper[];
  errors: IValidationErrorForShipper[];
}
